/**
 * Header language: keep Weglot switcher, hide Shopify header EN.
 * Mobile order: [hamburger] … [logo] … [Weglot EN] [account] [cart]
 */
(function () {
  var MQ = '(max-width: 1199px)';
  var pinning = false;

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function headerBody() {
    return document.querySelector('.wt-header--fashion .wt-header__body');
  }

  function hide(el) {
    if (!el) return;
    el.setAttribute('data-naori-lang-hidden', '1');
    el.setAttribute('aria-hidden', 'true');
    el.style.setProperty('display', 'none', 'important');
  }

  function show(el) {
    if (!el) return;
    el.removeAttribute('data-naori-lang-hidden');
    el.removeAttribute('aria-hidden');
    el.style.removeProperty('display');
  }

  function weglotSwitcher(root) {
    if (!root) return null;
    var nodes = root.querySelectorAll(
      '.weglot-container, .wg-default, #weglot-switcher, .wg-drop, [class*="weglot-"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // Skip scripts/styles and anything already inside the menu drawer
      if (el.closest && el.closest('.wt-drawer, .wt-localization-drawer')) continue;
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') continue;
      return el;
    }
    return null;
  }

  function pin() {
    if (pinning) return;
    pinning = true;

    try {
      var body = headerBody();
      if (!body) return;

      var aside = body.querySelector(':scope > .wt-header__aside');
      var panel = body.querySelector(':scope > .wt-header__panel');
      var slot = body.querySelector('.wt-header__panel__item--localization');
      var navTeaser = body.querySelector(':scope > .wt-header__nav-teaser');

      // Mobile: hamburger group first
      if (isMobile() && aside) {
        var afterTeaser = navTeaser ? navTeaser.nextSibling : body.firstChild;
        if (aside !== afterTeaser && aside.previousSibling !== navTeaser) {
          body.insertBefore(aside, afterTeaser);
        }
      }

      // Hide Shopify header language switcher (keep menu-drawer one alone)
      body
        .querySelectorAll(
          '.wt-header__localization__triggers:not(.wt-header__localization__triggers--menu-drawer)'
        )
        .forEach(hide);

      // Prefer Weglot switcher in the slot left of account
      var wg =
        weglotSwitcher(slot) ||
        weglotSwitcher(panel) ||
        weglotSwitcher(body) ||
        weglotSwitcher(document);

      if (wg) {
        show(wg);
        if (slot && !slot.contains(wg)) {
          slot.appendChild(wg);
        } else if (panel && !panel.contains(wg)) {
          var account = panel.querySelector('.wt-header__panel__item--account');
          panel.insertBefore(wg, account || panel.firstChild);
        }
      }
    } finally {
      pinning = false;
    }
  }

  function bindWeglot() {
    if (!window.Weglot || typeof window.Weglot.on !== 'function') return false;
    window.Weglot.on('initialized', pin);
    window.Weglot.on('languageChanged', pin);
    return true;
  }

  function start() {
    pin();

    if (!bindWeglot()) {
      var tries = 0;
      var timer = setInterval(function () {
        pin();
        if (bindWeglot() || ++tries > 50) clearInterval(timer);
      }, 100);
    }

    var body = headerBody();
    if (body && window.MutationObserver) {
      var scheduled = false;
      var obs = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          pin();
        });
      });
      obs.observe(body, { childList: true, subtree: true });
      // Also watch document for late Weglot inject outside header
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () {
        obs.disconnect();
      }, 12000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', pin);
})();
